import { createContext, useContext } from "react";

export interface MobileHeaderSlot {
  /** The element in the mobile top bar that a page's breadcrumb renders into. */
  element: HTMLElement | null;
  /** Marks the slot as filled (the shell hides its logo); returns the release. */
  claim: () => () => void;
}

/** Provided by MobileShell only; `null` on desktop/tablet, where pages render their own bar. */
export const MobileHeaderSlotContext = createContext<MobileHeaderSlot | null>(null);

export function useMobileHeaderSlot(): MobileHeaderSlot | null {
  return useContext(MobileHeaderSlotContext);
}
